export const openDB = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('fluxi-db', 1);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains('optimization')) {
                db.createObjectStore('optimization');
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const openDBCurrency = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('fluxi-db', 2);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains('currency')) {
                db.createObjectStore('currency');
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const getOptimization = async (funnelId: string): Promise<boolean> => {
    const db = await openDB();
    return new Promise((resolve) => {
        const tx = db.transaction('optimization', 'readonly');
        const store = tx.objectStore('optimization');
        const request = store.get(funnelId);
        request.onsuccess = () => resolve(!!request.result);
        request.onerror = () => resolve(false);
    });
};

export const setOptimization = async (funnelId: string, value: boolean) => {
    const db = await openDB();
    const tx = db.transaction('optimization', 'readwrite');
    const store = tx.objectStore('optimization');
    if (value) {
        store.put(true, funnelId);
    } else {
        store.delete(funnelId);
    }
};

export const setCurrency = async (value: boolean) => {
    const db = await openDBCurrency();
    const tx = db.transaction('currency', 'readwrite');
    const store = tx.objectStore('currency');
    
    store.put(value, 'currency');
};

export const getCurrency = async (): Promise<boolean> => {
    const db = await openDBCurrency();
    return new Promise((resolve) => {
        const tx = db.transaction('currency', 'readonly');
        const store = tx.objectStore('currency');
        const request = store.get('currency');
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => resolve(false);
    });
};
